<template>
  <div>
    <b-modal class="h-50" scrollable id="modal-log" centered title="Log Data Absen Karyawan" header-bg-variant="primary" header-text-variant="light" @show="showModal()">
      <div v-if="data && dataLog">
        <p>{{ dataLog.namaTanggalAbsen }}</p>
      </div>
      <div v-if="!data && !dataLog" class="d-flex justify-content-center">
        <br />
        <br />
        <br />
        <span class="pt-4 pb-4">TIDAK ADA DATA LOG</span>
        <br />
        <br />
        <br />

        <!-- <pre>{{ dataEdit }}</pre> -->
      </div>
      <div v-else>
        <!-- <div class="container">
          <div class="row">
            <div class="col">
              <ol class="pl-4 m-0">
                <li v-for="i in 10" :key="i" class="fw-lighter text-muted pl-1">
                  <div class="d-flex justify-content-between">
                    <div>
                      <p class="fw-light">
                        {{ `Absen ${i%2 === 0 ? 'berhasil' : 'gagal'}` }}
                      </p>
                    </div>
                    <div>
                      <p>Radius <span class="text-primary">{{ 500 + i }}</span></p>
                    </div>
                    <div>
                      <p class="fw-light fst-italic">
                        {{ `18:${3 + i < 10 ? '0' + (3 + i) : 3 + i}` }}
                      </p>
                    </div>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div> -->
        <div class="container">
          <div v-for="i in 10" :key="i" class="row">
            <div class="col-1 pr-0">
              {{ i }}.
            </div>
            <div class="col-4 pl-0">
              Absen <span :style="{ color: i % 2 == 0 ? 'red' : 'green' }">{{ i % 2 == 0 ? "Berhasil" : "Gagal" }}</span>
            </div>
            <div class="col-3">
              Radius 545
            </div>
            <div class="col text-right">
              <!-- <span class="text-right"> -->
                18.30
              <!-- </span> -->
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-log')"> Tutup </b-button>
        <!-- <b-button variant="primary" @click="simpan()">
          {{ button }}
        </b-button> -->
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "modalLog",
  props: ["data", "dataLog"],
  data() {
    return {
      button: "Simpan",
      busy: false,
      listKaryawan: [],
      shift: [],
      status: [
        { value: 0, text: "Tepat Waktu" },
        { value: 1, text: "Terlambat" },
        // { value: 2, text: "Ijin Terlambat" },
      ],
      status2: [
        { value: 0, text: "Berangkat" },
        { value: 1, text: "Cuti" },
        { value: 2, text: "Dinas" },
        { value: 3, text: "Cuti Hamil" },
        { value: 4, text: "Ijin" },
        { value: 5, text: "Sakit" },
        { value: 6, text: "Alpha" },
        { value: 7, text: "Ijin Keluarga Meninggal" },
        { value: 8, text: "Cuti Istri Melahirkan" },
        { value: 9, text: "Cuti Menikah" },
        { value: 10, text: "Ijin Jatah Libur" },
      ],
      absenMasuk: 0,
    };
  },
  computed: {
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mounted() {
    this.getKaryawan();
    console.log(this.data);
    console.log(this.dataLog);
    
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    showModal() {
      const vm = this;
      vm.absenMasuk = vm.dataLog.terlambat ? 1 : 0;
    },
    inputAbsenMasuk(x) {
      const vm = this;
      if (!x) {
        vm.dataLog.terlambat = 0;
      }
    },
    inputTerlambat(x) {
      const vm = this;
      vm.absenMasuk = x == 0 ? 0 : 1;
    },
    Absenadates(x) {
      if (x) {
        return this.$moment(this.dataLog.tanggalAbsen).format("LL");
      } else {
        return "";
      }
    },
    async getKaryawan() {
      let vm = this;

      let shift = await vm.$axios.post("masterShift/list");
      // console.log(shift.data.data, "shift");
      vm.shift = shift.data.data.map((item) => {
        return { value: item.id, text: item.kategoriShift };
      });
    },

    simpan() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.$axios
        .post("absensiKaryawanMobile/updateStatusTerlambat", {
          ...vm.dataLog,
          id: vm.dataLog.absensiKaryawanMobileId,
        })
        .then((res) => {
          console.log(res.data.message);
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "success",
              msg: "BERHASIL INPUT DATA ABSEN KARYAWAN",
              showing: true,
            });
            vm.$bvModal.hide("modal-telat");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
          }
        })
        .catch((err) => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$emit("alertFromChild", {
            variant: "danger",
            msg: err.message,
            showing: true,
          });
          // vm.$bvModal.hide("modal-input");
        });
    },
  },
};
</script>
